function debugLogger (...args) {
  if (import.meta.env.VITE_DEBUG_INFO === 'true') {
    console.log(...args) // eslint-disable-line
  }
}

export { debugLogger }
